import cx from 'classnames';
import DatePicker from 'react-datepicker';
import { EthenaDate } from '../../../lib/helpers/dateHelper';
import css from './Form.module.scss';

/**
 * DatePicker that takes in UTC dates and returns out UTC dates. Context for
 * why we need this: https://github.com/Hacker0x01/react-datepicker/issues/1787
 */
export const UtcDatePicker = ({
  className,
  endDate,
  maxDate,
  minDate,
  onChange,
  selected,
  startDate,
  ...rest
}) => {
  const localDateToUtcDate = (date) => new EthenaDate(date).toPureDateFormat();
  const utcDateToLocalDate = (date) =>
    date ? new EthenaDate(date).toLocalStartOfDate() : undefined;
  return (
    <DatePicker
      className={cx(css.datePicker, className)}
      endDate={utcDateToLocalDate(endDate)}
      maxDate={utcDateToLocalDate(maxDate)}
      minDate={utcDateToLocalDate(minDate)}
      onChange={(date) => onChange(localDateToUtcDate(date))}
      selected={utcDateToLocalDate(selected)}
      startDate={utcDateToLocalDate(startDate)}
      {...rest}
    />
  );
};
